import {fromRoute} from '@synako/enhanced-router';
import index from './ffconnect';

const cadencier = fromRoute(index, {
  path: '/mes-produits/cadencier',
});
const inspect_search = fromRoute(index, {
  path: '/inspect/search',
});
const inspect_remplacement = fromRoute(index, {
  path: '/inspect/remplacement',
});
const inspect_nomenclature = fromRoute(index, {
  path: '/inspect/nomenclature',
});
const inspect_produit_marche = fromRoute(index, {
  path: '/inspect/produit-marche',
});
const panier_default = fromRoute(index, {
  path: '/panier',
});
const panier = fromRoute<{date_panier_actif: string}>(index, {
  path: 'panier/:date_panier_actif',
});
const panier_redirect = fromRoute<{date_de_livraison: string}>(index, {
  path: 'panier/redirect/:date_de_livraison',
});
const panier_marketplace = fromRoute<{marketplace_id: string}>(index, {
  path: 'panier/marketplace/:marketplace_id',
});
const paiement_1p6 = fromRoute(index, {
  path: '/ffconnect/1p6',
});

const catalogue = fromRoute(index, {
  path: '/catalogue',
});

const produit = fromRoute<{code_article: string}>(index, {
  path: '/produit/:code_article',
});

const produit_marketplace = fromRoute<{
  marketplace_id: string;
  ref_tiers?: string;
}>(index, {
  path: '/produit/:marketplace_id/:ref_tiers',
});

const recherche = fromRoute(index, {
  path: '/recherche',
});
const mentions = fromRoute(index, {
  path: '/mentions_legales',
});
const mentionsContenu = fromRoute(index, {
  path: '/mentions_legales/contenu',
});
const listes_default = fromRoute(index, {
  path: '/mes-produits/listes',
});
const listes = fromRoute<{code_liste: string}>(index, {
  path: '/mes-produits/listes/:code_liste',
});
// Regroupement Mes Produits
const mes_produits = fromRoute(index, {
  path: '/mes-produits',
});
const mes_produits_par_saison = fromRoute(index, {
  path: '/mes-produits/par-saison',
});
const mes_produits_devis = fromRoute(index, {
  path: '/mes-produits/devis',
});
const mes_produits_operation_commerciale = fromRoute(index, {
  path: '/mes-produits/operation-commerciales',
});
const mes_produits_operation_commerciale_detail = fromRoute<{
  id_operation_commerciale: string;
}>(index, {
  path: '/mes-produits/operation-commerciales/:id_operation_commerciale',
});
const mes_produits_ub_essentielles = fromRoute(index, {
  path: '/mes-produits/ub-essentielles',
});
const cache = fromRoute(index, {
  path: '/cache',
});
const accueil = fromRoute(index, {
  path: '/accueil',
});
const menuClient = fromRoute(index, {
  path: '/menuClient',
});
const profil = fromRoute(index, {
  path: '/profil',
});
const commandes = fromRoute(index, {
  path: '/commandes',
});
const commande_detail = fromRoute(index, {
  path: '/commandes/:cle_commande',
});
const factures = fromRoute(index, {
  path: '/factures',
});
const livraisons = fromRoute(index, {
  path: '/livraisons',
});
const contacts = fromRoute(index, {
  path: '/contacts',
});
const preferences = fromRoute(index, {
  path: '/preferences',
});
const clientSelect = fromRoute(index, {
  path: '/client/select',
});
const backOffice = fromRoute(index, {
  path: '/backoffice',
});
const backOfficeClients = fromRoute(index, {
  path: '/backoffice/clients',
});

// Route pour le Backoffice Operation Commerciales
const backOfficeOperationsCommerciales = fromRoute<{
  id_societe_commerciale: string;
}>(index, {
  path: '/backoffice/operations-commerciales/:id_societe_commerciale',
});
const backOfficeModifierOperationsCommerciales = fromRoute<{
  id_societe_commerciale: string;
  id_operation_commerciale: string;
}>(index, {
  path: '/backoffice/operations-commerciales/:id_societe_commerciale/:id_operation_commerciale/modifier',
});

const backOfficeAjouterSocieteCommerciale = fromRoute(index, {
  path: '/backoffice/societes-commerciales/ajouter',
});
const backOfficeModifierSocieteCommerciale = fromRoute<{
  societe_commerciale_id: string;
}>(index, {
  path: '/backoffice/societes-commerciales/:societe_commerciale_id/modifier',
});
const backOfficeSocieteCommercialeClientsSelect = fromRoute<{
  id_societe_commerciale: string;
}>(index, {
  path: '/backoffice/societes-commerciales/:id_societe_commerciale/clients',
});
const backOfficeSocieteCommercialeClientDetail = fromRoute<{
  id_societe_commerciale: string;
  id_client: string;
}>(index, {
  path: '/backoffice/societes-commerciales/:id_societe_commerciale/clients/:id_client',
});
// Route pour la Prise de Commande
const backOfficePriseCommande = fromRoute<{id_societe_commerciale: string}>(
  index,
  {
    path: '/backoffice/commande/:id_societe_commerciale',
  },
);
// TODO: à revoir
const backOfficePriseCommandeNouvelleCommande = fromRoute<{
  id_societe_commerciale: string;
  id_client: string;
  date_de_livraison?: string;
}>(index, {
  path: '/backoffice/paniers/:id_societe_commerciale/:id_client/:date_de_livraison',
});
// TODO: à revoir
const backOfficePriseCommandePanier = fromRoute<{
  id_societe_commerciale: string;
  id_client: string;
  date_de_livraison?: string;
}>(index, {
  path: '/backoffice/paniers/:id_societe_commerciale/:id_client/:date_de_livraison',
});
// Route pour accéder à un panier PDF par son ID
const backOfficePriseCommandePanierPdf = fromRoute<{
  id_societe_commerciale: string;
  id_client: string;
  panier_id: string;
}>(index, {
  path: '/backoffice/paniers/:id_societe_commerciale/:id_client/pdf/:panier_id',
});

// Routes pour les Devis Tarifaires Personnalisés
// Pour la liste des clients
const backOfficeDevis = fromRoute<{id_societe_commerciale: string}>(index, {
  path: '/backoffice/devis/:id_societe_commerciale',
});
// Pour le détail d'un devis spécifique
const backOfficeDevisDetail = fromRoute<{
  id_societe_commerciale: string;
  id_client: string;
  devis_id: string;
}>(index, {
  path: '/backoffice/devis/:id_societe_commerciale/:id_client/:devis_id',
});

// Route pour le Catalogue Grand Compte
const catalogueGrandCompte_path = '/catalogue-grand-compte';
const catalogueGrandCompte = fromRoute(index, {
  path: catalogueGrandCompte_path,
});
const catalogueGrandCompteSearch = fromRoute(index, {
  path: `${catalogueGrandCompte_path}/search`,
});
const backOfficeCatalogueGrandCompte = fromRoute(index, {
  path: `/backoffice${catalogueGrandCompte_path}`,
});
const backOfficeCatalogueGrandCompteSearch = fromRoute(index, {
  path: `/backoffice${catalogueGrandCompte_path}/search`,
});

const backOfficeParsePdfOrder = fromRoute<{id_societe_commerciale: string}>(
  index,
  {
    path: '/backoffice/societes-commerciales/:id_societe_commerciale/commandes-pdf',
  },
);
const backOfficeParsePdfOrderProcessus = fromRoute<{
  id_societe_commerciale: string;
  processus_pdf_id: string;
}>(index, {
  path: '/backoffice/societes-commerciales/:id_societe_commerciale/commandes-pdf/:processus_pdf_id',
});

// Route pour le Changelog du Backoffice
const backOfficeChangelog = fromRoute(index, {
  path: '/backoffice/changelog',
});

// Route pour la Roadmap du Backoffice (page d'accueil : accès + édition)
const backOfficeRoadmap = fromRoute(index, {
  path: '/backoffice/roadmap',
});

// Route pour le contenu HTML pur de la roadmap
const backOfficeRoadmapContenu = fromRoute(index, {
  path: '/backoffice/roadmap/contenu',
});

// Route pour le Backoffice Maintenance
const backOfficeMaintenance = fromRoute(index, {
  path: '/backoffice/maintenance',
});

// Route d'édition pour une maintenance programmée
const backOfficeMaintenanceEdit = fromRoute<{
  maintenance_programmee_id: string;
}>(index, {
  path: '/backoffice/maintenance/:maintenance_programmee_id',
});

const backOfficeAdministrationFonctionnalites = fromRoute(index, {
  path: '/backoffice/administration-fonctionnalites',
});

// Routes pour "Mes droits"
const mesDroits = fromRoute<{id_societe_commerciale: string}>(index, {
  path: '/backoffice/mes-droits/:id_societe_commerciale',
});

// Routes pour Synako - Choix du commercial à impersonner
const mesDroitsSynako = fromRoute<{id_societe_commerciale: string}>(index, {
  path: '/backoffice/mes-droits/:id_societe_commerciale/synako',
});

// Route pour le Canal Collaboratif
const backOfficeConversations = fromRoute<{id_societe_commerciale: string}>(
  index,
  {
    path: '/backoffice/conversations/:id_societe_commerciale',
  },
);

// Routes pour les conversations client (mobile)
const conversations = fromRoute(index, {
  path: '/conversations',
});
const conversationDetail = fromRoute<{participation_id: string}>(index, {
  path: '/conversations/:participation_id',
});
const conversationNouvelle = fromRoute(index, {
  path: '/conversations/nouvelle',
});

// Routes pour Egalim
const egalim = fromRoute(index, {
  path: '/egalim',
});

export default {
  cadencier,
  mes_produits,
  mes_produits_par_saison,
  mes_produits_devis,
  mes_produits_operation_commerciale,
  mes_produits_operation_commerciale_detail,
  mes_produits_ub_essentielles,
  inspect_search,
  inspect_remplacement,
  inspect_nomenclature,
  inspect_produit_marche,
  panier,
  panier_default,
  panier_redirect,
  panier_marketplace,
  paiement_1p6,
  catalogue,
  produit,
  produit_marketplace,
  recherche,
  mentions,
  mentionsContenu,
  listes_default,
  listes,
  cache,
  menuClient,
  profil,
  accueil,
  commandes,
  commande_detail,
  preferences,
  factures,
  livraisons,
  contacts,
  clientSelect,
  backOffice,
  backOfficeClients,
  backOfficeOperationsCommerciales,
  backOfficeModifierOperationsCommerciales,
  backOfficeAjouterSocieteCommerciale,
  backOfficeModifierSocieteCommerciale,
  backOfficeSocieteCommercialeClientsSelect,
  backOfficeSocieteCommercialeClientDetail,
  backOfficePriseCommande,
  backOfficePriseCommandePanier,
  backOfficePriseCommandeNouvelleCommande,
  backOfficePriseCommandePanierPdf,
  catalogueGrandCompte,
  catalogueGrandCompteSearch,
  backOfficeCatalogueGrandCompte,
  backOfficeCatalogueGrandCompteSearch,
  backOfficeParsePdfOrder,
  backOfficeParsePdfOrderProcessus,
  backOfficeChangelog,
  backOfficeRoadmap,
  backOfficeRoadmapContenu,
  backOfficeMaintenance,
  backOfficeMaintenanceEdit,
  backOfficeAdministrationFonctionnalites,
  backOfficeDevis,
  backOfficeDevisDetail,
  mesDroits,
  mesDroitsSynako,
  backOfficeConversations,
  conversations,
  conversationDetail,
  conversationNouvelle,
  egalim,
};
